var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 4.71,
    viewBox: "0 0 6 4.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drop",
    transform: "translate(-0.999 -1.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M5.375,8c-.451,0-.691.663-.394,1.087L7.3,12.4a.644.644,0,0,0,1.105,0l2.317-3.31c.3-.424.056-1.087-.394-1.087H5.375Z",
    transform: "translate(-3.851 -6.216)",
    fill: "#65666a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowIcon);
export default __webpack_public_path__ + "static/media/select_arrow_icon.86a82c1ca0bc565be5329f3e81188956.svg";
export { ForwardRef as ReactComponent };